import { useModal } from "../Modal";
import { ModalSheet } from "../ModalSheet";
import { Button } from "../../ui/button";
import { ContactUs } from "../../infoSection/ContactUs";
import type { useDiagnosticsModal } from "../../diagnostics/Diagnostics";

type DiagnosticsModal = ReturnType<typeof useDiagnosticsModal>;

export function useContactUsModal(diagnosticsModal: DiagnosticsModal) {
  const modal = useModal(() => {
    return (
      <ModalSheet
        title="Contact Us"
        onClose={() => modal.close()}
        showHeaderCloseIcon={true}
        footer={
          <div className="flex justify-between items-center mt-2">
            <Button
              buttonType="linkButton"
              onClick={() => diagnosticsModal.open()}
              className="text-md px-[9px] h-[27px]"
            >
              Send Diagnostics
            </Button>
            <Button onClick={() => modal.close()} buttonType="closeSecondary" className="font-medium">
              Close
            </Button>
          </div>
        }
      >
        <div className="overflow-y-auto max-h-[80vh] text-foreground">
          <ContactUs />
        </div>
      </ModalSheet>
    );
  });

  return modal;
}
